import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export function deficienciesReducer(state = initialstate.deficiencies, action) {
	switch (action.type) {
		case types.GET_ALL_DEFICIENCIES:
			return action.response || state;
		case types.CREATE_DEFICIENCY:
			if (!isApiResponseOk(action)) {
				return state;
			}
			if (action.actionArgs.updateState && action.response) {
				let newState;
				const responseData = Array.isArray(action.response)
					? action.response[0]
					: action.response;

				if (Object.keys(state).length === 0) {
					newState = {
						data: [responseData]
					};
				} else {
					newState = {
						...state,
						data: [...state.data, responseData]
					};
				}
				return newState;
			}
			return state;
		case types.UPDATE_DEFICIENCY:
			if (!isApiResponseOk(action) || !action.response || !state.data) {
				return state;
			}
			const updatedDeficiencies = state.data.map(deficiency =>
				deficiency.id === action.response.id
					? {
						...deficiency,
						deficiencyShortName: action.response.deficiencyShortName,
						description: action.response.description
					}
					: deficiency
			);

			return {
				...state,
				data: updatedDeficiencies
			};
		case types.DELETE_DEFICIENCY:
			if (!isApiResponseOk(action) || !action.payload || !state.data) {
				return state;
			}
			const filteredDeficiencies = state.data.filter((deficiency) => deficiency.id !== action.payload.deficiencyId);
			return {
				...state,
				data: filteredDeficiencies
			};
		default:
			return state;
	}
}
